import { RobotAngryIcon } from './RobotAngryIcon';

/**
 * author: Colton Wiscombe
 * id D77B4057-E06B-49B7-BBC7-DD4A7B39BC2A
 * name robot-angry
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot-angry.svg
 * tags
 */
export const EmoticonRobotAngryIcon = RobotAngryIcon;
export default EmoticonRobotAngryIcon